import { RetailerKey } from 'flow/types/EntityKeys';
import { browserSupportStorage } from './browser-storage-utils';
import wrappedLocalStorage from './local-storage-utils';
import { apiUrl, dev, proxyUrl } from 'app-config';

const CENTRAL_SWITCH_WIDGETS = 'centralSwitchWidgets';

export const UAE_APP_URL = 'cloudtalk.etisalat.ae';
// Telavox's own hosts in the UAE cluster, e.g. the AE predeploy Home.
const UAE_TELAVOX_DOMAIN = '.ae.telavox.com';

/* In dev the proxy target is the real region, so it overrides — but never replaces — `apiUrl`. */
const urlApi = (dev && proxyUrl) || apiUrl;
export const IS_UAE_HOST =
    !!urlApi?.endsWith(UAE_APP_URL) || !!urlApi?.endsWith(UAE_TELAVOX_DOMAIN);
// Internal UAE cluster hosts (predeploy) sit behind no WAF, so they have no /roaming-status.
export const IS_UAE_INTERNAL_HOST = !!urlApi?.endsWith('.svc.ae.telavox.com');

// UK is not a single deployment like UAE — UK-branded apps are served from various `.co.uk`
// APP_FLOW_URLs — so we detect the region by the `.co.uk` TLD rather than a fixed host. Match
// against the parsed hostname (not the raw string) so a path, port or trailing slash on
// APP_FLOW_URL — or a nullish / malformed value — can't break detection.
const UK_APP_TLD = '.co.uk';

const appHostName = (() => {
    try {
        const raw = apiUrl ?? '';
        const hasProtocol =
            raw.startsWith('http://') || raw.startsWith('https://');
        return new URL(hasProtocol ? raw : `https://${raw}`).hostname;
    } catch {
        return null;
    }
})();

export const IS_UK_HOST = !IS_UAE_HOST && !!appHostName?.endsWith(UK_APP_TLD);

export const isRetailerRainbow = (retailerId: RetailerKey) =>
    !IS_UAE_HOST && ['retailer-1211'].includes(retailerId);

export const getCentralSwitchWidgets = () => {
    const DefaultWidgets = Object.freeze([
        'dialPad',
        'favoritePBX',
        'RecentContacted',
        'userCalendar',
    ]);

    if (!browserSupportStorage()) {
        return DefaultWidgets;
    } else {
        return wrappedLocalStorage.isSet(CENTRAL_SWITCH_WIDGETS)
            ? JSON.parse(wrappedLocalStorage.getItem(CENTRAL_SWITCH_WIDGETS))
            : DefaultWidgets;
    }
};
